<template>
  <div>
    <div class="deposit-slips-header"></div>
    <tol-table :table-data="depositSlips" :columns="columns" :show-spinner="isLoading">
      <template v-slot:tableHeader>
        <th>{{ $t('depositSlips.listing.depositNumber') }}</th>
        <th>{{ $t('depositSlips.listing.endDate') }}</th>
        <th>{{ $t('depositSlips.listing.fileName') }}</th>
        <th></th>
      </template>
      <template v-slot:click-action="{ value }">
        <td class="click-action">
          <div class="download">
            <font-awesome-icon icon="file-pdf" @click="downloadDepositSlip(value)" />
          </div>
        </td>
      </template>
    </tol-table>
    <Pagination
      :records-per-page="depositSlipsPerPage"
      :offset="currentPage"
      :record-count="depositSlipsCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>

<script>
import TolTable from '@/app/components/TolTable';
import Pagination from '@/app/components/Pagination';
import { AppActions } from '@/app/app.keys';
import {
  DepositSlipsGetters,
  DepositSlipsActions
} from '@/app/features/deposit-slips/deposit-slips.keys';
export default {
  name: 'DepositSlips',
  components: {
    TolTable,
    Pagination
  },
  computed: {
    isLoading() {
      return this.$store.getters[DepositSlipsGetters.DepositSlipsLoading];
    },
    depositSlips() {
      return this.$store.getters[DepositSlipsGetters.DepositSlips];
    },
    columns() {
      return ['deposit_number', 'end_date', 'original_name'];
    },
    depositSlipsPerPage() {
      return this.$store.getters[DepositSlipsGetters.DepositSlipsPerPage];
    },
    currentPage() {
      return this.$store.getters[DepositSlipsGetters.DepositSlipsOffset];
    },
    depositSlipsCount() {
      return this.$store.getters[DepositSlipsGetters.DepositSlipsRecordCount];
    }
  },

  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('depositSlips.listing.title'));
    this.$store.dispatch(DepositSlipsActions.RetrieveDepositSlips);
  },

  methods: {
    onChangePaginationParams(evt) {
      this.$store.dispatch(DepositSlipsActions.SetDepositSlipsPagination, evt);
    },
    downloadDepositSlip(evt) {
      this.$store.dispatch(DepositSlipsActions.DownloadDepositSlip, evt);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors';
@import '@/app/styles/variables';

.deposit-slips-header {
  display: flex;
  background-color: $background-level-2;
  padding: 60px;
}
.click-action {
  .download {
    position: relative;
    text-align: center;
    width: 30px;
    height: 30px;
    border: 1px solid $light-grey-1;
    border-radius: 50%;
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &:hover {
      cursor: pointer;
      border-color: $green;
    }
  }
}
</style>
